export function getFromCookie(key: string): string | null {
	if (!window.navigator.cookieEnabled) {
		return null;
	}

	const cookieArr = document.cookie.match('(?:^|;\\s*)' + key + '=([^;]*)');

	return cookieArr?.[1] ?? null;
}
